import * as R from "ramda";

import Interval from "utility/Interval";

const sort = R.sortWith<any>([
	R.ascend(x => (R.isNil(x[0]) ? 0 : 1)),
	R.ascend(x => x[0]),
	R.ascend(x => (R.isNil(x[1]) ? 1 : 0)),
	R.ascend(x => x[1])
]);

const sortIntervals = <T>(intervals: Interval<T>[]): Interval<T>[] => sort(intervals);

export default sortIntervals;
